import { __decorate } from "tslib";
// NPM
import { Component, Mixins, Vue } from "vue-property-decorator";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import Loader from "../../../components/widgets/loader.vue";
import simplebar from "simplebar-vue";
import * as signalR from "@microsoft/signalr";
import Timer from "@/components/clockWork/timer.vue";
import { VUE_APP_APP_CW_HUB_URL } from "@/services/config";
import { AuthModule } from "@/store/modules/auth.module";
import _ from "lodash";
import LiveViewUserEntryComponent from "./components/LiveViewUserEntryComponent.vue";
import DayViewUserEntryComponent from "./components/DayViewUserEntryComponent.vue";
import WeekViewUserEntryComponent from "./components/WeekViewUserEntryComponent.vue";
import DayViewProjectEntryComponent from "./components/DayViewProjectEntryComponent.vue";
import LiveViewProjectEntryComponent from "./components/LiveViewProjectEntryComponent.vue";
import WeekViewProjectEntryComponent from "./components/WeekViewProjectEntryComponent.vue";
import HeartBeat from "@/components/heart-beat.vue";
import workViewMachine from "./machines/workViewMachine";
import { interpret } from "xstate";
import { WorkViewModule } from "@/store/modules/workView.module";
/**
 * CCW Component
 */
Component.registerHooks(["metaInfo"]);
let Workview = /** @class */ (() => {
    let Workview = class Workview extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.isLive = false;
            this.isDay = false;
            this.isWeek = false;
            this.showKS = false;
            this.title = "Work View";
            // MACHINE
            this.machine = workViewMachine.withContext({
                operationDate: new Date(),
                displayDate: new Date(),
                teamId: "",
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.totalSeconds = 0;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Analytics",
                    href: "#",
                },
                {
                    text: "WorkView",
                    active: true,
                },
            ];
            this.today = new Date();
            this.teamId = "";
        }
        liveEntryMode() {
            this.isDay = false;
            this.isWeek = false;
            this.isLive = true;
            this.send({ type: "LIVE_USERS_ENTRIES", teamId: this.teamId });
        }
        dayViewMode() {
            this.isLive = false;
            this.isWeek = false;
            this.isDay = true;
            this.send({ type: "DAY_USERS_ENTRIES", teamId: this.teamId });
        }
        weekViewMode() {
            this.isLive = false;
            this.isDay = false;
            this.isWeek = true;
            this.send({ type: "WEEK_USERS_ENTRIES", teamId: this.teamId });
        }
        send(event) {
            this.machineService.send(event);
        }
        disabledAfterToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date > new Date(today.getTime());
        }
        displayDateChanged(value, type) {
            if (value !== null) {
                this.send({ type: "CHANGE_DISPLAY_DATE", teamId: this.teamId, value: value });
            }
        }
        prevDay() {
            this.send({ type: "PREV_DAY", teamId: this.teamId });
        }
        nextDay() {
            if (!this.isToday) {
                this.send({ type: "NEXT_DAY", teamId: this.teamId });
            }
        }
        goToProjectMode() {
            if (this.isLive) {
                this.send({ type: "PROJECT_LIVE_USERS_ENTRIES", teamId: this.teamId });
            }
            else if (this.isDay) {
                this.send({ type: "PROJECT_DAY_USERS_ENTRIES", teamId: this.teamId });
            }
            else {
                this.send({ type: "PROJECT_WEEK_USERS_ENTRIES", teamId: this.teamId });
            }
        }
        goToUserMode() {
            if (this.isLive) {
                this.send({ type: "LIVE_USERS_ENTRIES", teamId: this.teamId });
            }
            else if (this.isDay) {
                this.send({ type: "DAY_USERS_ENTRIES", teamId: this.teamId });
            }
            else {
                this.send({ type: "WEEK_USERS_ENTRIES", teamId: this.teamId });
            }
        }
        changeTeamId(teamId) {
            this.send({ type: "CHANGE_TEAM", teamId: this.teamId });
        }
        toggleKsWindow() {
            this.showKS = !this.showKS;
        }
        closeKsWindow() {
            this.showKS = false;
        }
        updateTotalTime(projectId, totalTime) {
            const project = this.sortedDayViewProjectModeEntries.find((p) => p.projectId === projectId);
            project.totalTime = totalTime;
        }
        get isToday() {
            return this.state.context.operationDate.toDateString() == this.state.context.displayDate.toDateString();
        }
        get liveViewUserModeEntries() {
            return WorkViewModule.liveViewUserModeEntries;
        }
        get sortLiveViewUserModeEntries() {
            var runningEntries = _.filter(this.liveViewUserModeEntries, (x) => x.clockWorkEntryId != null);
            var emptyEntries = _.filter(this.liveViewUserModeEntries, (x) => x.clockWorkEntryId == null);
            var sortedRunningEntries = _.orderBy(runningEntries, (item) => [item.startTime], ["desc"]);
            var sortedEmptyEntries = _.orderBy(emptyEntries, (item) => [item.fullName], ["asc"]);
            return sortedRunningEntries.concat(sortedEmptyEntries);
        }
        get dayViewUserModeEntries() {
            return WorkViewModule.dayViewUserModeEntries;
        }
        get keymap() {
            return {
                h: this.prevDay,
                l: this.nextDay,
            };
        }
        get liveViewProjectModeEntries() {
            return WorkViewModule.liveViewProjectModeEntries;
        }
        get sortedLiveViewProjectModeEntries() {
            return _.orderBy(this.liveViewProjectModeEntries, (item) => item.projectName);
        }
        get dayViewProjectModeEntries() {
            return WorkViewModule.dayViewProjectModeEntries;
        }
        get sortedDayViewProjectModeEntries() {
            return _.orderBy(this.dayViewProjectModeEntries, (item) => item.totalTime, "desc");
        }
        get teamList() {
            return WorkViewModule.teams;
        }
        async initializeSignalR() {
            var accessKey = "";
            if (AuthModule.isAuthenticated && AuthModule.accessToken) {
                accessKey = `${AuthModule.accessToken}`;
            }
            const options = {
                accessTokenFactory: () => accessKey,
            };
            // SignalR Configuration
            const apiUrl2 = VUE_APP_APP_CW_HUB_URL;
            this.connection = new signalR.HubConnectionBuilder()
                .withUrl(apiUrl2, options)
                .configureLogging(signalR.LogLevel.Information)
                .build();
            this.connection.on("entryReceived", (entry) => {
                for (var i = 0; i < this.liveViewUserModeEntries.length; i++) {
                    if (this.liveViewUserModeEntries[i].employeeId == entry.employeeId) {
                        this.liveViewUserModeEntries[i].description = entry.description != "" ? entry.description : "Untitled Entry";
                        this.liveViewUserModeEntries[i].projectDisplayString = entry.projectDisplayString;
                        this.liveViewUserModeEntries[i].clockWorkEntryId = entry.clockWorkEntryId;
                        this.liveViewUserModeEntries[i].taskDisplayString = entry.taskDisplayString;
                        this.liveViewUserModeEntries[i].totalTimeInSeconds = entry.totalTimeInSeconds;
                        this.liveViewUserModeEntries[i].startTimeTzFormatted = entry.startTimeTzFormatted;
                        this.liveViewUserModeEntries[i].endTimeTzFormatted = entry.endTimeTzFormatted;
                        this.liveViewUserModeEntries[i].startTime = entry.startTime;
                        this.liveViewUserModeEntries[i].projectCode = entry.projectCode == null ? "" : entry.projectCode;
                        this.liveViewUserModeEntries[i].taskCode = entry.taskCode == null ? "" : entry.taskCode;
                        this.liveViewUserModeEntries[i].isViewable = entry.isViewable;
                        this.liveViewUserModeEntries[i].projectId = entry.projectId;
                        this.liveViewUserModeEntries[i].isWFO = entry.isWFO;
                        this.liveViewUserModeEntries[i].entryAtWork = entry.entryAtWork;
                    }
                }
            });
            this.connection.on("deletedEntryReceived", (employeeId) => {
                for (var i = 0; i < this.liveViewUserModeEntries.length; i++) {
                    if (this.liveViewUserModeEntries[i].employeeId == employeeId.toString()) {
                        this.liveViewUserModeEntries[i].description = "";
                        this.liveViewUserModeEntries[i].clockWorkEntryId = null;
                        this.liveViewUserModeEntries[i].projectDisplayString = "Unassigned";
                        this.liveViewUserModeEntries[i].taskDisplayString = "Unassigned";
                        this.liveViewUserModeEntries[i].taskCode = "";
                        this.liveViewUserModeEntries[i].projectCode = "";
                        this.liveViewUserModeEntries[i].totalTimeInSeconds = 0;
                        this.liveViewUserModeEntries[i].startTimeTzFormatted = "";
                        this.liveViewUserModeEntries[i].endTimeTzFormatted = "";
                    }
                }
            });
            await this.connection
                .start()
                .then(() => {
                console.log("Connection extablished.");
            })
                .catch((err) => {
                document.write(err);
            });
        }
        mounted() {
            window.addEventListener("keydown", this.handleKeydown);
        }
        handleKeydown(event) {
            if (event.altKey) {
                const key = event.key.toLowerCase();
                event.preventDefault();
                switch (key) {
                    case "l":
                        this.liveEntryMode();
                        break;
                    case "d":
                        this.dayViewMode();
                        break;
                    case "w":
                        this.weekViewMode();
                        break;
                    default:
                        break;
                }
            }
        }
        // Lifecycle
        async created() {
            await this.initializeSignalR();
            this.machineService.start();
            console.log("Machine started");
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                console.log(state.toStrings());
                this.today = this.state.context.displayDate;
                this.showKS = false;
                if (this.state.matches("loadedTeamsList") && previousState.matches("gettingTeamsList")) {
                    this.teamId = this.teamList.length > 0 ? this.teamList[0].id.toString() : "";
                }
                if (this.state.matches("loadedTeamsList")) {
                    this.send({ type: "LIVE_USERS_ENTRIES", teamId: this.teamId });
                }
                if (this.state.matches("loadedLiveViewUserModeEntries") && previousState.matches("gettingLiveViewUserModeEntries")) {
                    Vue.nextTick(() => {
                        console.log("Inside next tick");
                        if (this.connection.state === signalR.HubConnectionState.Connected) {
                            console.log("Connection is started");
                        }
                        else {
                            console.log("Connection is not started");
                        }
                        this.connection.invoke("JoinTeam", WorkViewModule.liveViewUserModeEntries[0].teamId).catch(function (err) {
                            return console.error(err.toString());
                        });
                    });
                    this.isLive = true;
                }
            });
        }
        beforeUnmount() {
            window.removeEventListener("keydown", this.handleKeydown);
        }
        destroyed() {
            this.connection.invoke("LeaveTeam", WorkViewModule.liveViewUserModeEntries[0].teamId).catch(function (err) {
                return console.error(err.toString());
            });
            WorkViewModule.clearLiveViewUserModeEntries();
            this.machineService.stop();
        }
    };
    Workview = __decorate([
        Component({
            name: "Workview",
            components: {
                Layout,
                PageHeader,
                Loader,
                Timer,
                HeartBeat,
                simplebar,
                LiveViewUserEntryComponent,
                DayViewUserEntryComponent,
                DayViewProjectEntryComponent,
                LiveViewProjectEntryComponent,
                WeekViewUserEntryComponent,
                WeekViewProjectEntryComponent,
            },
        })
    ], Workview);
    return Workview;
})();
export default Workview;
